export default __webpack_public_path__ + "static/media/adam.eafd76b4.jpeg";